// extracted by mini-css-extract-plugin
module.exports = {"summaryOverview":"styles_summaryOverview__FmPsN","summaryRowChange":"styles_summaryRowChange__cIBfA","summaryRow":"styles_summaryRow__D324y"};